import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { Outlet } from "react-router-dom";
import Box from "@mui/material/Box";
import { CssBaseline } from "@mui/material";
import Header from "./components/Header/Header";
import { StoreContext } from "../../App";
import { SuittService } from "../../services/index";
import { getUserInfoFromLocalStorage } from "../../utils/index";
import Footer from "./components/Footer/Footer";

function CabinetLayout() {
  const suittService = useMemo(() => new SuittService(), []);
  const { auth } = useContext(StoreContext);
  const [user, setUser] = useState({});
  const didFetchRef = useRef(false);

  useEffect(() => {
    if (didFetchRef.current) return;
    didFetchRef.current = true;
    const user = getUserInfoFromLocalStorage();
    if (user?._id) {
      (async () => {
        auth.setUser(user);
        const result = await suittService.getUserInfo(user._id);
        if (result.data) {
          auth.setUser(result.data);
          setUser(result.data);
        }
      })();
    }
  }, [auth, suittService]);

  return (
    <Box sx={{ flexDirection: "column" }}>
      <CssBaseline />
      <Header />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          width: "100%",
          minHeight: "100vh",
          flexGrow: 1,
        }}
      >
        <Outlet />
        <Footer />
      </Box>
    </Box>
  );
}

export default CabinetLayout;
